import { render, staticRenderFns } from "./BurgerMenuIcon.vue?vue&type=template&id=7fe4f469&"
import script from "./BurgerMenuIcon.vue?vue&type=script&lang=js&"
export * from "./BurgerMenuIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports